/** Shown on /support when the FAQ API returns empty — keeps the page useful for visitors and reviewers. */
export const SUPPORT_FALLBACK_FAQS = [
	{
		question: 'What is Visit All Nepal?',
		answer: 'Visit All Nepal is a Nepal travel guide and booking platform. We publish free guided journeys for major treks, plus destination guides, festival information, and trip-planning resources. When you are ready to travel, you can also book group departures, private tours, or shared rides through us.',
	},
	{
		question: 'Do I need a visa to visit Nepal?',
		answer: 'Most visitors need a Nepal visa. Many nationalities can obtain a visa on arrival at Tribhuvan International Airport in Kathmandu or at land border crossings. See our visa guide at visitallnepal.com/visa for current requirements, fees, and documents to bring.',
	},
	{
		question: 'What are guided journeys?',
		answer: 'Guided journeys are step-by-step trek planners on Visit All Nepal — from visa and flights through permits, packing, day-by-day routes, budgets, and safety. Browse all journeys at visitallnepal.com/journeys.',
	},
	{
		question: 'How do group departures work?',
		answer: 'You pick a trek and departure month, submit your details, and pay a small deposit. We gather travellers until the group reaches the minimum size, confirm the departure, and assign a verified local operator. You pay the remaining balance after the group is confirmed.',
	},
	{
		question: 'How do private tours work?',
		answer: 'Tell us which journey you want and your preferred dates on the private tours page. We review your request, send options and a quote, and assign an operator if you proceed. Every private tour is customized to your group.',
	},
	{
		question: 'How can I contact support?',
		answer: 'Email admin@visitallnepal.com or use the contact form on this page. Include your booking reference if you have one. We respond to trip-planning and booking questions from our Nepal-based team.',
	},
	{
		question: 'When is the best time to trek in Nepal?',
		answer: 'October–November and March–May are the two classic trekking windows — clear skies and stable weather. June–September is monsoon (harder for high-altitude treks). December–February is cold but quiet. See visitallnepal.com/seasonal-discovery for month-by-month advice.',
	},
	{
		question: 'What permits do I need for trekking?',
		answer: 'Most treks require a TIMS card plus a national park or conservation area permit. Restricted regions like Upper Mustang need a special permit through a registered agency. Our guided journeys list exact permits for each route at visitallnepal.com/journeys.',
	},
	{
		question: 'Do I need travel insurance for Nepal?',
		answer: 'Yes — especially for trekking. Standard policies often exclude high-altitude evacuation. You need cover that includes helicopter rescue to at least 5,500m for Everest Base Camp. See our insurance guide at visitallnepal.com/plan/insurance.',
	},
	{
		question: 'What is altitude sickness and how do I prevent it?',
		answer: 'Acute Mountain Sickness (AMS) can occur above 2,500m. Symptoms include headache, nausea, and dizziness. Prevention: ascend slowly, acclimatize, stay hydrated, and descend if symptoms worsen. Never fly into Lukla and trek the same day. More at visitallnepal.com/safety.',
	},
	{
		question: 'How do I get from Kathmandu to Pokhara?',
		answer: 'Options include a 25-minute domestic flight, a 6–7 hour tourist bus, or a private car. Flights are fastest but weather-dependent; buses are the budget standard. See visitallnepal.com/transportation for details.',
	},
	{
		question: 'Can I get a SIM card at Kathmandu airport?',
		answer: 'Yes — Ncell and Nepal Telecom sell tourist SIM packages in the arrivals area. Bring your passport and a passport photo. NTC has better rural coverage; Ncell is strong in Kathmandu and Pokhara.',
	},
	{
		question: 'Is Nepal safe for solo travelers?',
		answer: 'Nepal is generally safe for tourists. Use Tourist Police (1144, toll-free, 24/7) for help. Common issues are low-level scams in Thamel — use ride-apps, licensed agencies, and bank ATMs. On trek, hire a guide for restricted areas and carry evacuation insurance.',
	},
	{
		question: 'What currency should I bring?',
		answer: 'Nepali Rupees (NPR) for everyday spending. USD works for visa fees and some hotels. Withdraw NPR from ATMs in cities before trekking — trails are cash-only. Exchange at banks or licensed counters, not street vendors.',
	},
	{
		question: 'How do I pay for a booking on Visit All Nepal?',
		answer: 'Group departure deposits and other payments can be made through supported methods shown at checkout (including Khalti and other local options where available). You receive email confirmation with your booking reference.',
	},
	{
		question: 'Can I cancel or change my booking?',
		answer: 'Cancellation and change policies depend on the service type and how close you are to the departure date. Contact admin@visitallnepal.com with your booking reference — we will explain options for your specific reservation.',
	},
];
